import { CirclePicker, PhotoshopPicker, SketchPicker, TwitterPicker } from "react-color";
import { PRIMARY_COLOR } from "../../../../../utils/theme/getPrimaryColor";
import { useContext, useRef, useState } from "react";
import { ThemeContext } from "../../../../../context/ThemeContext";
import { Edit, Edit2 } from "iconsax-react";
import { getToken } from "../../../../../utils/token";
import { toast } from "react-toastify";
import instance, { url } from "../../../../../axios/instance";
import { useLoaderData } from "react-router-dom";


export default function ThemePage() {

    const { setThemeColor } = useContext(ThemeContext)

    const { facility } = useLoaderData()

    const defaultColors = [
        '#00b0ad', 
        '#F44E3B', 
        '#FE9200', 
        '#FCDC00', 
        '#DBDF00', 
        '#A4DD00', 
        '#68CCCA', 
        '#AEA1FF', 
        '#FDA1FF', 
        '#333333', 
        '#D33115', 
        '#E27300', 
        '#FCC400', 
        '#B0BC00', 
        '#68BC00', 
        '#16A5A5', 
        '#009CE0', 
        '#7B64FF', 
        '#FA28FF', 
        '#000000', 
        '#9F0500', 
        '#C45100', 
        '#FB9E00', 
        '#808900', 
        '#194D33', 
        '#0C797D', 
        '#0062B1', 
        '#653294', 
        '#AB149E'
    ]

    function setPrimaryColor(color) {

        // set theme color to db

        instance.post("/doctor/theme/update", {
            theme_color: color
        }, {
            headers: {
                Authorization: `Bearer ${getToken()}`
            }
        })
        .then(response => {
            console.log(response.data);
            toast.success("Theme updated")
            // window.location.reload()
        })
        .catch(error => {
            console.log(error.response.data);
            toast.error(error.response.data.message)
        })

        window.localStorage.setItem(PRIMARY_COLOR, color)
        setThemeColor(color)
    }

    const logoRef = useRef()

    const [file, setFile] = useState(null)
    const [previewImage, setPreviewImage] = useState(!facility.logo_path ? "/images/logo1.png" : `${url}${facility.logo_path}`);

    function handleFileSelect() {
        logoRef.current.click();
    }


    function updateLogo() {
        const formData = new FormData()
        formData.append("file", file)
        instance.post("/doctor/logo/update", formData, {
            headers: {
                Authorization: `Bearer ${getToken()}`
            }
        })
        .then(response => {
            console.log(response.data);
            toast.success("Logo changed")
            window.location.reload()
        })
        .catch(error => {
            console.log(error.response.data);
            toast.error(error.response.data.message)
        })
        
    }
    

    return (
        <div className="p-3">

            <div className="">
                <div className="w-[250px] relative border p-3 rounded-[6px]">
                    <input 
                        type="file" 
                        ref={logoRef} 
                        className="hidden" 
                        accept="image/png, image/jpeg, image/jpg"
                        onChange={e => {
                            setFile(e.target.files[0])
                            const reader = new FileReader();
                            reader.onload = () => {
                                setPreviewImage(reader.result); // Set the image preview
                            };
                            reader.readAsDataURL(e.target.files[0]); // Read the file as a data URL
                        }}
                    />

                    <img src={previewImage} width={200} />
                    <button onClick={handleFileSelect} className="absolute -right-4 -bottom-2 w-8 h-8 bg-primary flex rounded-full shadow-md items-center justify-center">
                        <Edit2 size={14} variant="Bold" color="#fff" />
                    </button>
                </div>
               
            </div>

            {
                file &&
                <button 
                    onClick={updateLogo}
                    className="bg-primary shadow-md mt-2 px-4 py-2 text-[14px] font-medium text-white rounded-[4px]"
                >Update logo</button>
            }
           


            <div className="mt-10"></div>
            <TwitterPicker 
                width="100%" 
                onChangeComplete={color => setPrimaryColor(color.hex)}
                colors={defaultColors}
            /> 

        </div>
    )
}